import { render, staticRenderFns } from "./goods-allocation.vue?vue&type=template&id=15f42cb2&scoped=true"
import script from "./goods-allocation.vue?vue&type=script&lang=js"
export * from "./goods-allocation.vue?vue&type=script&lang=js"
import style0 from "./goods-allocation.vue?vue&type=style&index=0&id=15f42cb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f42cb2",
  null
  
)

export default component.exports